module.exports = __webpack_public_path__ + "img/code.dbbdf7d6.png";